import ReferralErrorPage from "./ReferralErrorPage";
export default ReferralErrorPage;
